import {TEMPLATE_FIELD_NAMES, TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES} from '../../constants/issue-templates';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import {getIsoDateDaysFromNow} from '../../utils/date-helpers';

const attributeHandlers = {
  [TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.DUE_DATE]: (acc, dueDate) => {
    acc[ISSUE_ATTRIBUTE_NAMES.DUE_DATE] = getIsoDateDaysFromNow(dueDate);
  },
  [TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.CUSTOM_ATTRIBUTES]: (acc, customAttributes) => {
    customAttributes.forEach(({attributeDefinitionId, value: customAttributeValue}) => {
      acc[attributeDefinitionId] = customAttributeValue;
    });
  }
};

const TEMPLATE_ISSUE_ATTRIBUTE_MAPPING = {
  [TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.TITLE]: ISSUE_ATTRIBUTE_NAMES.TITLE,
  [TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.DESCRIPTION]: ISSUE_ATTRIBUTE_NAMES.DESCRIPTION,
  [TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.STATUS]: ISSUE_ATTRIBUTE_NAMES.STATUS,
  [TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.SUBTYPE_ID]: ISSUE_ATTRIBUTE_NAMES.ISSUE_SUB_TYPE_ID,
  [TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.ROOT_CAUSE_ID]: ISSUE_ATTRIBUTE_NAMES.ROOT_CAUSE_ID,
  [TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.ASSIGNED_TO]: ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO,
  [TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.ASSIGNED_TO_TYPE]: ISSUE_ATTRIBUTE_NAMES.ASSIGNED_TO_TYPE,
  [TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.LOCATION_ID]: ISSUE_ATTRIBUTE_NAMES.LOCATION_ID,
  [TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.LOCATION_DETAILS]: ISSUE_ATTRIBUTE_NAMES.LOCATION_DETAILS,
  [TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES.OWNER_ID]: ISSUE_ATTRIBUTE_NAMES.OWNER_ID
};

export default ({issueAttributes = {}, [TEMPLATE_FIELD_NAMES.ID]: id} = {}, currentUserId) =>
  Object.values(TEMPLATE_ISSUE_ATTRIBUTES_FIELD_NAMES).reduce(
    (acc, attributeName) => {
      if (issueAttributes.hasOwnProperty(attributeName)) {
        const attributeValue = issueAttributes[attributeName];
        if (attributeHandlers[attributeName]) {
          attributeHandlers[attributeName](acc, attributeValue);
        } else if (TEMPLATE_ISSUE_ATTRIBUTE_MAPPING[attributeName]) {
          acc[TEMPLATE_ISSUE_ATTRIBUTE_MAPPING[attributeName]] = attributeValue;
        }
      }
      return acc;
    },
    {
      [ISSUE_ATTRIBUTE_NAMES.TEMPLATE_ID]: id,
      [ISSUE_ATTRIBUTE_NAMES.OWNER_ID]: currentUserId
    }
  );
